import { render, staticRenderFns } from "./RiskAreaDetail.vue?vue&type=template&id=4bf9239e&scoped=true"
import script from "./RiskAreaDetail.vue?vue&type=script&lang=js"
export * from "./RiskAreaDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskAreaDetail.vue?vue&type=style&index=0&id=4bf9239e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9239e",
  null
  
)

export default component.exports